export default __webpack_public_path__ + "static/media/main-menu-2.0042de2a.mp3";